angular.module('wbServices').service('customValidation', [ ->
  @isValid = (type, value) =>
    switch type
      when 'sin'
        @isValidSin(value)
      else
        false

  # Copied to modules/common/input-taxid/taxid-validator; no longer use this.
  @isValidSin = (sin) ->
    return false if _.isEmpty(sin)

    # Standardize any incoming SIN to be #########
    sin = sin.replace(/[^\d]/gi, '')

    # Make sure it is nine characters
    return false if sin.length isnt 9

    # Check if it passes the checksum
    check = [1, 2, 1, 2, 1, 2, 1, 2, 1]
    sinArray = sin.split('')
    multiplied = []
    for i in [0..sinArray.length - 1]
      sincheck = parseInt(check[i]) * parseInt(sinArray[i])
      sincheck = _.sumBy(String(sincheck).split(''), (n) -> Number(n)) if sincheck > 9
      multiplied.push sincheck

    return _.sum(multiplied) % 10 is 0

  @
])
